import React,{useState,useEffect} from 'react';
import { Message, Divider, Label } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { Button,Icon,Input } from 'semantic-ui-react';
import logo from "../../images/logo/logo-white.png";
import LoadingComponent from "../common/LoadingComponent";
import ModalHeader from './../drive/ModalHeader';
const errorLabel = (
    <div 
      className="customErrorLabel" 
      style={{
        position: 'absolute',
        bottom: '-16px',
        left: '10px',
        color: 'red',
        fontSize: '8px'
      }}
    />
  );


const formatCountdown = (secondsLeft) => {
    const minutes = Math.floor(secondsLeft / 60);
    const seconds = secondsLeft % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
}

const LoginComponent = ({ loggingIn, loginError, gotToRegister,handleGoogleLogin, onSubmit, gotToForgotPassword, goToSubscription,handleMicrosoftLogin, version,goToNewAccount, goToSetupCredentials, otpMode, otpSent, otpExpiresAt, otpRequestError, onToggleOtpMode, onResendOtp}) => {

    const [password, setPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [email, setEmail] = useState('')
    const [otp, setOtp] = useState('')
    const [secondsLeft, setSecondsLeft] = useState(0)
    const [resendCooldown, setResendCooldown] = useState(0)
    const [otpEmailError, setOtpEmailError] = useState(false)
    const [pageStep, setPageStep] = useState('email')
    const date = new Date()

    const mode = otpMode ? 'otp' : 'password';
    const isValidEmail = !!email && /\S+@\S+\.\S+/.test(email);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword)
      }

    useEffect(() => {
        if (!otpMode || !otpExpiresAt) {
            return;
        }
        const tick = () => {
            const remaining = Math.max(0, Math.round((otpExpiresAt - Date.now()) / 1000));
            setSecondsLeft(remaining);
        };
        tick();
        const interval = setInterval(tick, 1000);
        return () => clearInterval(interval);
    }, [otpMode, otpExpiresAt]);

    useEffect(() => {
        if (!otpSent) {
            return;
        }
        setResendCooldown(30);
        const interval = setInterval(() => {
            setResendCooldown(prev => (prev > 0 ? prev - 1 : 0));
        }, 1000);
        return () => clearInterval(interval);
    }, [otpExpiresAt]);

    const handleSwitchToOtp = (e) => {
        e.preventDefault();
        if (!isValidEmail) {
            setOtpEmailError(true);
            return;
        }
        setOtpEmailError(false);
        onToggleOtpMode(true, email);
    }

    const handleSwitchToPassword = (e) => {
        e.preventDefault();
        setOtpEmailError(false);
        setOtp('');
        onToggleOtpMode(false);
    }

    const handleResendOtp = (e) => {
        e.preventDefault();
        if (resendCooldown > 0) {
            return;
        }
        onResendOtp(email);
    }

    const handleBack = (e) => {
        e.preventDefault();
        setOtpEmailError(false);
        setPassword('');
        setOtp('');
        onToggleOtpMode(false);
        setPageStep('email');
    }

    const handleFormSubmit = (formData) => {
        if (pageStep === 'email') {
            setPageStep('credentials');
            return;
        }
        onSubmit({ ...formData, email });
    }

    return(
    
    <div className="login-main">
         <LoadingComponent active={loggingIn} message="Logging in" />
       
        <div className="left-section">
            <div className='centered' style={{ justifyContent: "flex-start", paddingTop: "80px" }}>
                <h2 className="f_24 ff_b float-left" style={{ color:"#707070", fontWeight: "normal", display: "flex", alignItems: "center", gap: "8px" }}>
                    {
                        pageStep === 'credentials' ? (
                            <a href="#" onClick={handleBack} id="backLink" style={{
                                display: "flex", alignItems: "center", justifyContent: "center",
                                width: "28px", height: "28px",
                                border: "1px solid #d4d4d4", borderRadius: "6px",
                                color: "#707070", textDecoration: "none"
                            }}>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="15 18 9 12 15 6"></polyline>
                                </svg>
                            </a>
                        ) : ''
                    }
                    {pageStep === 'credentials' ? `Log In with ${mode === 'otp' ? 'Code' : 'Password'}` : 'Log In'}
                </h2>
                <Form noValidate
                    className="loginform"
                    error
                    onValidSubmit={handleFormSubmit}
                    id="loginform"

                >

                    {
                        loginError != null && (loginError.message === "Invalid login"
                            || loginError.message === "OTP has expired"
                            || loginError.message === "User is Deactivated." || loginError.message === "No users in Database" || loginError.message === "User not registered") ?
                            <Message
                                error
                                content={otpMode ? `That code is incorrect or has expired.` : `Invalid email/password!`}
                            /> : ''
                    }
                    {
                        otpRequestError != null ?
                            <Message
                                error
                                content={`Could not send a code to that email. Please try again.`}
                            /> : ''
                    }

                    {
                        pageStep === 'email' ? (
                            <div style={{ paddingLeft: "10px",gap:"10px", marginLeft: "-10px", position: "relative", marginBottom: "18px"}}>
                                <Form.Input
                                    name="email"
                                    label="Email"
                                    placeholder="Enter Email"
                                    icon="envelope"
                                    iconPosition="left"
                                    required
                                    validations="isEmail"
                                    errorLabel={errorLabel}
                                    validationErrors={{
                                        isEmail: 'This is not a valid email',
                                        isDefaultRequiredValue: 'Email is required',
                                    }}
                                    value={email}
                                    onChange={(e) => { setEmail(e.target.value); setOtpEmailError(false); }}
                                    id="email"
                                    autoFocus
                                    style={{
                                            marginTop: "1px"
                                        }}
                                />
                                {
                                    otpEmailError ?
                                        <div style={{ color: "red", fontSize: "11px", marginTop: "6px" }}>Please enter a valid email above to continue.</div>
                                        : ''
                                }
                            </div>
                        ) : (
                            <>
                                <div style={{ paddingLeft: "10px", marginLeft: "-10px", marginBottom: "16px" }}>
                                    <span style={{ fontSize: "14px", color: "#707070", display: "block" }}>
                                        {mode === 'otp' ? 'Enter the one-time code sent to' : 'Enter your password for'}
                                    </span>
                                    <p style={{ fontSize: "14px", fontWeight:"700" }}>{email}</p>
                                </div>
                                {
                                    mode === 'otp' ? (
                                        <>
                                            <div style={{ paddingLeft: "10px",gap:"10px", marginLeft: "-10px", position: "relative",marginBottom:"18px"}}>
                                                <Form.Input
                                                    icon='shield'
                                                    iconPosition='left'
                                                    label="One-Time Code"
                                                    type="password"
                                                    required
                                                    placeholder="Enter Code"
                                                    autoComplete="one-time-code"
                                                    name="otp"
                                                    errorLabel={errorLabel}
                                                    validationErrors={{
                                                        isDefaultRequiredValue: 'Code is required',
                                                    }}
                                                    value={otp}
                                                    id="otp"
                                                    autoFocus
                                                    onChange={(e) => setOtp(e.target.value)}
                                                    style={{marginTop:"1px",letterSpacing:"2px"}}
                                                />
                                            </div>
                                            <div style={{ paddingLeft: "10px", marginLeft: "-10px", display: "flex", justifyContent: "space-between", fontSize: "10.5px", color: "#7a7a7a", marginBottom: "5px" }}>
                                                <span>{secondsLeft > 0 ? `Code expires in ${formatCountdown(secondsLeft)}` : 'Code expired'}</span>
                                                <a href="#" onClick={handleResendOtp} style={{ color: resendCooldown > 0 ? "#b7b7b7" : "#3EA2F7", fontWeight: "bold", cursor: resendCooldown > 0 ? "default" : "pointer" }}>
                                                    {resendCooldown > 0 ? `Resend code (${resendCooldown}s)` : 'Resend code'}
                                                </a>
                                            </div>
                                        </>
                                    ) : (
                                        <div style={{ paddingLeft: "10px",gap:"10px", marginLeft: "-10px", position: "relative",marginBottom:"20px"}}>
                                            <Form.Input
                                                icon='key'
                                                iconPosition='left'
                                                label="Password"
                                                type={showPassword ? 'text' : 'password'}
                                                required
                                                placeholder="Enter Password"
                                                autoComplete="current-password"
                                                name="password"
                                                errorLabel={errorLabel}
                                                validationErrors={{
                                                    isDefaultRequiredValue: 'Password is required',
                                                }}
                                                value={password}
                                                id="password"
                                                action={<Icon
                                                    name={showPassword ? 'eye' : 'eye slash'}
                                                    link
                                                    onClick={togglePasswordVisibility}
                                                    style={{left: "auto", right: "1px"}}
                                                />}
                                                onChange={(e) => setPassword(e.target.value)}
                                                autoFocus
                                                style={{borderRightColor:'1 px solid red',marginTop:"1px"}}
                                            />
                                        </div>
                                    )
                                }

                                <div style={{ paddingLeft: "10px", marginLeft: "-10px", marginBottom: "14px" }}>
                                    <Form.Checkbox
                                        name="rememberMe"
                                        label="Remember me"
                                        style={{ fontSize: '13px' }}
                                    />
                                </div>
                            </>
                        )
                    }

                    <div style={{ paddingLeft: "10px", marginLeft: "-10px" }}>
                        <Button className="button-submit ff_sb" type="submit" id="submit" style={{width:"100%", fontSize: "12px"}}>{pageStep === 'email' ? 'Continue' : (mode === 'otp' ? 'Verify & Log In' : 'Log In')}</Button>
                        <div style={{ marginTop: "10px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                            {
                                pageStep === 'credentials' && (
                                    mode === 'otp' ? (
                                        <a href="#" className="typeAnchor underline-hover" onClick={handleSwitchToPassword} id="passwordLoginLink" style={{textAlign:"center", fontSize:"12px", fontWeight:"normal"}}>Log in with password</a>
                                    ) : (
                                        <>
                                            <a href="#" className="typeAnchor underline-hover"  onClick={gotToForgotPassword} id="forgetLink" style={{textAlign:"center", fontSize:"12px", fontWeight:"normal"}}>Forgot Password?</a>
                                            <a href="#" className="typeAnchor underline-hover" onClick={handleSwitchToOtp} id="otpLoginLink" style={{textAlign:"center", fontSize:"12px", fontWeight:"normal"}}>Log in with a one-time code</a>
                                        </>
                                    )
                                )
                            }
                            {pageStep !== 'credentials' && (
                                <a href='newaccount' className="typeAnchor underline-hover ff_sb" onClick={goToNewAccount} style={{textAlign:"center", fontSize:"12px", fontWeight:"600", color:"#3EA2F7"}}>Create an Account</a>
                            )}
                        </div>
                    </div>
                        <hr style={{alignSelf: "stretch",marginTop: '15px', marginBottom: '25px', border: '0', borderTop: '1px solid #e2e2e094'}} />
                        <div style={{display:"flex", justifyContent:"center"}}>
                        <div style={{marginTop:"5px", width:"100%"}}>
                            <Button
                                onClick={handleGoogleLogin}
                                className='mar_tb_5 display-flex login-btn'
                                type="button"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="16px" height="16px">
                                <path fill="#4285F4" d="M46.8 24.42c0-1.42-.13-2.79-.36-4.12H24v7.77h12.84c-.56 3.01-2.22 5.55-4.73 7.26v6.02h7.66c4.48-4.13 7.04-10.22 7.04-16.93z"/>
                                <path fill="#34A853" d="M24 48c6.32 0 11.61-2.09 15.48-5.67l-7.66-6.02c-2.13 1.43-4.84 2.29-7.82 2.29-6.02 0-11.12-4.07-12.94-9.55H3.17v6.09C7.09 42.9 14.98 48 24 48z"/>
                                <path fill="#FBBC05" d="M11.06 28.75a14.63 14.63 0 0 1 0-9.49V13.17H3.17a24.03 24.03 0 0 0 0 21.66l7.89-6.08z"/>
                                <path fill="#EA4335" d="M24 9.42c3.33 0 6.31 1.15 8.67 3.4l6.47-6.47C34.51 2.47 29.92 0 24 0 14.98 0 7.09 5.1 3.17 13.17l7.89 6.08C12.88 13.49 17.98 9.42 24 9.42z"/>
                                </svg>
                                  <span style={{marginLeft:"4px", fontSize:"12px"}} className='ff_sb'> Log In with Google</span>
                            </Button>
                            <Button
                                onClick={handleMicrosoftLogin}
                                className='mar_tb_5 display-flex login-btn'
                                type="button"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="18px" height="18px">
                                <path fill="#F25022" d="M6 6h17v17H6z"/>
                                <path fill="#7FBA00" d="M25 6h17v17H25z"/>
                                <path fill="#00A4EF" d="M6 25h17v17H6z"/>
                                <path fill="#FFB900" d="M25 25h17v17H25z"/>
                                </svg>
                                <span style={{marginLeft:"4px", fontSize:"12px"}} className='ff_sb'> Log In with Microsoft</span>
                            </Button>
                            <hr style={{marginTop: '25px', marginBottom: '15px', border: '0', borderTop: '1px solid #e2e2e094'}} />                             
                            <p style={{ textAlign:"center", marginTop: '0px', fontSize: "11px", fontWeight: "500" }}>Thank you for your interest in Aspenify.</p>
                            <p style={{ textAlign:"center", fontSize:"11px", fontWeight:"500"}}>By logging in and use of the products, you agree to Aspenify's
                               <a href="https://aspenify.com/terms-of-service/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline"}}> Terms of Service</a>,
                               <a href="https://aspenify.com/privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline"}}> Privacy Policy</a> and 
                               <a href="https://aspenify.com/disclaimer/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline"}}> Disclaimer</a>.
                            </p>
                        </div>
                    </div>

                </Form>
            </div>
            <div className="f_8 mar_0 bottom" style={{  height: "46px", padding: "5px 10px",width:"100%"}}>
                <div className="float-left">
                    Copyright &#169; {date.getFullYear()} Aspenify <br />Version {version ? version : ""}
                </div>
                <div className="float-right text-right">
                    Visit us at <br />
                    <a href="https://www.aspenify.com" rel="noopener noreferrer" style={{ color: "#6b6b6b" }} target="_blank" > www.aspenify.com </a>
                </div>
            </div>
        </div>
                           
        <div className="right-section display-flex " style={{ flexDirection: 'column' }}>
            <div className='login-right-div ' >
            <div>
                <ModalHeader 
                header={<a href="https://aspenify.com" target="_blank" rel="noopener noreferrer"><img src={`${logo}`} alt="Logo" style={{ width: '40vw', height: 'auto', cursor:'pointer' }} /></a>}
                />
            </div>
            </div>
        </div>
    </div>
)};

export default LoginComponent;